import { memo } from "react";
import cc from "classcat";
import { Alert, useBreakpoints } from "@narmi/design_system";
import { Localized } from "@fluent/react";
import { useLoanMinimumPayment } from "byzantine/src/dbbl/businessLogic/modules/loanPayment";
import Account from "byzantine/src/Account";

type LoanPaymentBannerProps = {
  account: Account;
};

const LoanPaymentBanner = ({ account }: LoanPaymentBannerProps) => {
  const { l } = useBreakpoints();
  const { formattedMinimumPayment, isPaymentPastDue } = useLoanMinimumPayment(
    account.id
  );
  const goToLoanPayment = () => {
    window.location.assign(`/transfer/loans/?to_account_id=${account.id}`);
  };

  if (!account.isInternalLoan() || !isPaymentPastDue) {
    return null;
  }

  return (
    <div
      className={cc(["loan-payment-alert-container", l && "margin--top--m"])}
    >
      <Alert isActive kind="error" isDismissable={false}>
        <div>
          <Localized
            id="loan-payment-overdue-alert"
            vars={{ amount: formattedMinimumPayment }}
          >
            {`Your loan is overdue. Please make a payment of ${formattedMinimumPayment}.`}
          </Localized>
        </div>
        <div className="loan-payment-alert-link padding--top--xs">
          <button
            type="button"
            className="button--reset loan-payment-alert-link"
            onClick={goToLoanPayment}
          >
            <Localized id="loan-payment-overdue-alert-button">
              Make payment
            </Localized>
          </button>
        </div>
      </Alert>
    </div>
  );
};

export default memo(LoanPaymentBanner);
